import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import ApiService from "../../store/ApiService";
import { useTranslation } from "react-i18next";
import LineChart from "../../components/Charts/LineChart";
import Loader from "react-js-loader";
import PieChart from "../../components/Charts/PieChart";
import { changeNot } from "../../store/urlSlice";
import MainError from "../../components/Notifications/MainError";
import usePrivate from "../../store/useAxiosPrivate2";

function Purchase() {
  const { sendRequest } = usePrivate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const notification = useSelector(state => state.url.notification);
  const selectedCompany = useSelector(state => state.auth.selectedCompany);
  const BackUpType = useSelector(state => state.auth.backUpType);
  const [db, setdb] = useState(null);
  const [type, setType] = useState("chart");
  const currency = useSelector(state => state.auth.currency);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await sendRequest(
          "GET",
          `GetData/Purchase/${selectedCompany}/${BackUpType}`,
          null
        );
        console.log(res.result);
        dispatch(changeNot({ type: res.isSuccess, message: res.message }));
        setdb(res);
      } catch (err) {
        console.error(err);
        dispatch(changeNot({ type: err.isSuccess, message: err.message }));
        console.log(err);
      }
    };

    fetchData();
  }, [BackUpType, selectedCompany]);

  return db !== null ? (
    db.isSuccess ? (
      db.result.group.length > 0 ? (
        <div className="cash-detail">
          <div className="cash-head">
            <h3>
              {t("Dovr")}:{" "}
              {db.isSuccess
                ? db.result[`total${currency.text}`].toLocaleString("tr-TR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                : 0}{" "}
              <i className={currency.icon}></i>
            </h3>
            <ul className="show-type">
              <li
                className={type !== "table" ? "active" : "hide"}
                onClick={() => setType("table")}
              >
                <span>{t("Cədvəlgörünüşü")}</span>
                <i className="fa-solid fa-bars"></i>
              </li>
              <li
                className={type !== "chart" ? "active" : "hide"}
                onClick={() => setType("chart")}
              >
                <span>{t("Qrafikgörünüşü")}</span>
                <i className="fa-solid fa-chart-line"></i>
              </li>
            </ul>
          </div>
          <div className="pie">
            {type === "chart" ? (
              <PieChart
                s={db.result.group.map(d => d[`sum${currency.text}`])}
                l={db.result.group.map(d => d.purchaseproductgroup)}
              />
            ) : (
              <table className="table">
                <thead>
                  <tr>
                    <th>№</th>
                    <th>{t("Group")}</th>
                    <th>{t("Məbləğ")}</th>
                  </tr>
                </thead>
                <tbody>
                  {db.result.group.map((d, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{d.purchaseproductgroup}</td>
                        <td className="textal">
                          {d[`sum${currency.text}`].toLocaleString("tr-TR", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                          <i className={currency.icon}></i>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
          <div className="area">
            {type === "chart" ? (
              <LineChart
                data={db.result.history.map(d => {
                  return {
                    x: d.date,
                    y: d[`sum${currency.text}`].toLocaleString("tr-TR", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }),
                  };
                })}
                toolbar={true}
                height="100%"
                labelx={true}
                labely={true}
                icon={currency.id === 1 ? "₼" : currency.id === 3 ? "$" : "€"}
              />
            ) : (
              <table className="table">
                <tbody>
                  {[...db.result.history].reverse().map((d, i) => {
                    return (
                      <React.Fragment key={i}>
                        <tr className="date-row">
                          <td colSpan={6}>
                            {d.date} -{" "}
                            {d[`sum${currency.text}`].toLocaleString("tr-TR", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                            <i className={currency.icon}></i>
                          </td>
                        </tr>
                        {d.rows.map((row, j) => {
                          return (
                            <tr key={j}>
                              <td>{row.purchaseproductgroup}</td>
                              <td>{row.purchaseproductname}</td>
                              <td className="textal">{row.purchasequantity}</td>
                              <td>{row.purchaseunit}</td>
                              <td className="textal">
                                {row[
                                  `purchaseamount${currency.text}`
                                ].toLocaleString("tr-TR", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }) || 0}
                              </td>
                              <td>
                                <i className={currency.icon}></i>
                              </td>
                            </tr>
                          );
                        })}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
              // <table className="table">
              //   <thead>
              //     <tr>
              //       <th>№</th>
              //       <th>{t("Date")}</th>
              //       <th>{t("Qrupu")}</th>
              //       <th>{t("Adı")}</th>
              //       <th>{t("Miqdarı")}</th>
              //       <th>{t("Qiyməti")}</th>
              //     </tr>
              //   </thead>
              //   <tbody>
              //     {db.result.today.map((d, i) => {
              //       return (
              //         <tr>
              //           <td>{i + 1}</td>
              //           <td>{d.purchasedate}</td>
              //           <td>{d.purchaseproductgroup}</td>
              //           <td>{d.purchaseproductname} </td>
              //           <td>
              //             {d.purchasequantity} {d.purchaseunit}
              //           </td>
              //           <td>
              //             {d.purchaseamount} {d.purchasecurrency}
              //           </td>
              //         </tr>
              //       );
              //     })}
              //   </tbody>
              // </table>
            )}
          </div>
        </div>
      ) : (
        <div style={{ padding: "45px 13px" }}>
          <h2 className="section-head" style={{ marginLeft: "20px" }}>
            {t("Məlumatyoxdur")}
          </h2>
        </div>
      )
    ) : (
      <div style={{ padding: "45px 13px" }}>
        <h2 className="section-head" style={{ marginLeft: "20px" }}>
          {t("Məlumatyoxdur")}
        </h2>
        {notification ? <MainError /> : null}
      </div>
    )
  ) : (
    <div
      style={{
        width: "100%",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Loader
        type="box-rectangular"
        bgColor={"#0d2e4e"}
        color={"#0d2e4e"}
        title={"REPORTO"}
        size={80}
      />
    </div>
  );
}

export default Purchase;
